/**
 * P2B2: fail-closed projection of REAL Book entities.
 * Never substitute the static P2A display catalogue for persisted Book IDs.
 */
export function availablePaidVolumes(volumes) {
  return Array.isArray(volumes)
    ? volumes.filter(v => typeof v?.id === "string" && v.id && typeof v?.product_id === "string" && v.product_id && typeof v?.title === "string")
    : [];
}

export function inBookVolume(sections, volumeId) {
  return Array.isArray(sections)
    ? sections.filter(s => s?.id && s.volume_id === volumeId && s.title)
    : [];
}

export function inBookSection(subsections, volumeId, sectionId) {
  return Array.isArray(subsections)
    ? subsections.filter(s => s?.id && s.volume_id === volumeId && s.section_id === sectionId && s.title)
    : [];
}

export function inBookCategory(pages, volumeId, sectionId, subsectionId) {
  return Array.isArray(pages)
    ? pages.filter(p => p?.id && p.volume_id === volumeId && p.section_id === sectionId
        && p.subsection_id === subsectionId && p.title)
    : [];
}

export function confirmedBookPlacement(input, volumes, sections, subsections, pages) {
  const { volumeId, sectionId, subsectionId, pageId } = input || {};
  if (!availablePaidVolumes(volumes).some(v => v.id === volumeId)
    || !inBookVolume(sections, volumeId).some(s => s.id === sectionId)
    || !inBookSection(subsections, volumeId, sectionId).some(s => s.id === subsectionId)) return null;
  if (pageId && !inBookCategory(pages, volumeId, sectionId, subsectionId).some(p => p.id === pageId)) return null;
  return {
    book_volume_id: volumeId,
    section_id: sectionId,
    subsection_id: subsectionId,
    page_id: pageId || null,
    confirmed: true,
  };
}
